import { Injectable, signal } from '@angular/core';
import { EAnalyticsStatus } from '@shared/enums/campaign-analytics.enum';
import { EDeliverableType } from '@shared/enums/campaign.enum';
import { TDeliverableAnalyticsCollectionKey } from './cta-analytics-details.interface';

@Injectable({
  providedIn: 'root',
})
export class CtaAnalyticsDetailsService {
  public static readonly selectedDeliverableUniqueId = signal<string | null>(null);
  public static readonly previousSelectedDeliverableUniqueId = signal<string | null>(null);

  public static readonly DELIVERABLE_ANALYTICS_COLLECTION_MAP: Record<
    EDeliverableType,
    TDeliverableAnalyticsCollectionKey
  > = {
    [EDeliverableType.title]: 'titles',
    [EDeliverableType.gamePlay]: 'gamePlay',
    [EDeliverableType.chatBot]: 'chatbot',
    [EDeliverableType.chatbotMulti]: 'chatbotMultis',
    [EDeliverableType.talkingPoint]: 'talkingPoints',
    [EDeliverableType.talkingPointAi]: 'talkingPointAis',
    [EDeliverableType.visual]: 'visuals',
    [EDeliverableType.productPlacement]: 'productPlacements',
    [EDeliverableType.showcase]: 'showcases',
    [EDeliverableType.textTracking]: 'textTrackings',
    [EDeliverableType.audioTracking]: 'audioTrackings',
    [EDeliverableType.caption]: 'captions',
    [EDeliverableType.hashTag]: 'hashtags',
    [EDeliverableType.mention]: 'mentions',
    [EDeliverableType.message]: 'messages',
    [EDeliverableType.description]: 'descriptions',
    [EDeliverableType.content]: 'contents',
    [EDeliverableType.custom]: 'customs',
  } as const;

  public static readonly IMAGE_FINDING_DELIVERABLE_TYPES: EDeliverableType[] = [
    EDeliverableType.visual,
    EDeliverableType.showcase,
    EDeliverableType.content,
    EDeliverableType.custom,
  ] as const;

  public static readonly STATUS_SORT_VALUE_MAP: Record<EAnalyticsStatus, number> = {
    [EAnalyticsStatus.processing]: 0,
    [EAnalyticsStatus.failed]: 1,
    [EAnalyticsStatus.problem]: 2,
    [EAnalyticsStatus.ok]: 3,
  } as const;
}
